import styled from '@emotion/styled'
export const StyleCard = styled.div`
  background: ${(props: any) => props.theme.colors.yellow200};
  padding: 15px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  flex: 1;
  @media (max-width: 1024px) {
    width: 100%;
  }
`
